/** @jsx jsx */
import { Box } from '@bottlebooks/gatsby-theme-base';
import { jsx } from 'theme-ui';
import FilterField from '../Filters/FilterField';
import SearchResults from './SearchResults';
import useSiteSearch from './useSiteSearch';

export default function SiteSearch({
  initialTerm = '',
  variant,
  locale,

  ...rest
}) {
  const search = useSiteSearch({ initialTerm, locale });
  return (
    <Box>
      <FilterField
        variant={variant}
        value={search.term}
        onChange={search.setTerm}
        {...rest}
      />
      {search.term && (
        <SearchResults
          searchTerm={search.term}
          exhibitors={search.exhibitors}
          products={search.products}
          sx={{
            marginTop: 2,
            zIndex: 11, // TODO make this a portal instead.
            backgroundColor: ['light', null, 'white'],
            minWidth: [null, 500],
          }}
        />
      )}
    </Box>
  );
}
